import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { PlatesSection } from './components/PlatesSection';
import { MenuSection } from './components/MenuSection';
import { SalonSection } from './components/SalonSection';
import { VisitSection } from './components/VisitSection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-forest-900 font-sans text-cream-100" data-id="element-0" data-mp="2mluboumz01vx">
      <SiteHeader data-id="element-1" data-mp="2mjzmh44o1nm1" />
      <main data-id="element-2" data-mp="31agn4l9h89hv">
        <Hero data-id="element-3" data-mp="31b8lu4ydencd" />
        <StorySection data-id="element-4" data-mp="31bs1ff0jszn8" />
        <PlatesSection data-id="element-5" data-mp="31c9ygdv1bhw7" />
        <MenuSection data-id="element-6" data-mp="31cjog1g2xp1w" />
        <SalonSection data-id="element-7" data-mp="2wk9y4kb1ymz3" />
        <VisitSection data-id="element-8" data-mp="2wiyxgtcwlvc7" />
      </main>
      <SiteFooter data-id="element-9" data-mp="2whx9joashed2" />
    </div>;
}